import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import { TranslateContext } from "../TranslateContext";


const  GuaranteeDetails=({item:{infoId:id,code,ref},deleteData,updateData,saveData})=>{
 
  const GuaranteeTypeList=useSelector((state) => state.DropDownValues.partiesGuaranteeType);
  const translate = React.useContext(TranslateContext).translate;

  const isFormDisabled = false
  return (
    <Grid.Row>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom b-rw-0"
      >
        <DropDown
          id={`guaranteeType${id}`}
          label={translate("GUARANTEE_TYPE", {ns:["default", "parties"]})}
          boxNumber="44"
          disabled={isFormDisabled}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={GuaranteeTypeList}
          value={code}
          onChange={(value) =>{
            saveData(id, {"code":value})
            updateData(id,{"code": value})}
          }
        
        />
      </Grid.Column>
      <Grid.Column
        width="10"
        className="divFormFeild border-bottom"
      >
        <InputField
          isLabel={false}
          id={`guaranteeDesc${id}`}
          type="text"
          label={`${translate("GUARANTEE", {ns:["default", "parties"]})} ${translate("description", {ns:["default", "parties", "header"]})}`}
          value={ref}
          className={"field-bg"}
          clearInput={false}
          onChange={(value) =>updateData(id, {"ref":value})}
          onBlur={(value) =>saveData({id, ref})}
          disabled={isFormDisabled}
        />
      </Grid.Column>
  
      
    
      <Grid.Column width="1" className="icon-delete-add-info">
       
          <span>
          
              <Icon
                name="trash alternate outline"
                onClick={() => deleteData(id)}
                disabled={isFormDisabled}
              />
          
          </span>
      
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(GuaranteeDetails)
